import { SyntheticEvent, useEffect, useState } from 'react';

export function useTab<T = number>(initialValue?: T) {
  const [currentTab, setCurrentTab] = useState<T>(
    initialValue || (0 as unknown as T)
  );

  const handleChangeTab = (_: SyntheticEvent, newValue: any) => {
    const url = window.location.pathname + `?tab=${newValue}`;

    setCurrentTab(newValue);
    window.history.replaceState(
      {
        url,
        as: url,
        options: {},
        __N: true,
      },
      '',
      url
    );
  };

  useEffect(() => {
    const tab = new URLSearchParams(window.location.search).get('tab');
    if (!tab) return;
    setCurrentTab(
      (typeof currentTab === 'number' ? +tab : tab) as unknown as T
    );
  }, []);

  return { currentTab, setCurrentTab, handleChangeTab };
}
